import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";
import axios from "axios";

const refreshSysProps = async () => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=refeshSysProp&companyid=${user.companyid}`,
  );
  return response.data;
};

const useRefreshSysProps = (options = {}) => {
  return useMutation({
    mutationFn: refreshSysProps,
    ...options,
  });
};

export default useRefreshSysProps;
